import { takeLatest, fork } from "redux-saga/effects";
import { listFetchSaga, createSaga, updateSaga } from "./base-saga";
import BankAccountActions from "../constants/actions";
import BankAccountService from "../services";


export default fork(function*() {
    yield takeLatest(
        BankAccountActions.LENDER_ACCOUNTS.LIST.FETCH,
        listFetchSaga(BankAccountActions.LENDER_ACCOUNTS.LIST, BankAccountService.getLendingPartnerAccounts)
    );
    yield takeLatest(
        BankAccountActions.LENDER_ACCOUNTS.ACCOUNT.CREATE,
        createSaga(BankAccountActions.LENDER_ACCOUNTS.ACCOUNT, BankAccountService.createNewLenderAccounts)
    );
    yield takeLatest(
        BankAccountActions.LENDER_ACCOUNTS.ACCOUNT.UPDATE,
        updateSaga(BankAccountActions.LENDER_ACCOUNTS.ACCOUNT, BankAccountService.updateExistingLenderAccounts)
    );
});